import "./WelcomeScreen.scss";
import ApprovedImage from "../../../../Assets/Registration/Check_icon.svg"
import { useNavigate } from "react-router-dom";
import { ADMIN_ROLES, ROUTES, STORAGE_KEYS } from "../../../Utilities/Constants/Constants";
import { useEffect, useState } from "react";
import { GetSessionStorageData } from "../../../Services/Helpers/Helper";

const WelcomeScreen = ()=>{
    const [ roleId, setRoleId ]= useState("");
    const navigate = useNavigate();

    useEffect(()=>{
           let roleId :any= GetSessionStorageData(STORAGE_KEYS.ROLE);
           setRoleId(roleId);
    },[])
    return(
        <div className="row onboarding-wrapper">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 column-wrapper">
                <div className="approval-image-wrapper">
                    <img className="approval-icon"  src={ApprovedImage}/>
                    <h3 className="approval-text">Approved</h3>
                    {(roleId !==ADMIN_ROLES.SCHOOL  || roleId !==ADMIN_ROLES.UNIVERSITY) && <button className="btn btn-primary create-btn" onClick={()=>{navigate(ROUTES.CREATE_SESSIONS)}}>Create Sessions</button>}
                </div>
                
             
            </div>
        </div>
    )
    

};

export default WelcomeScreen;